const config = {
    apiKey: "AIzaSyD2ldDI-xx7Q8z3f1JkT2ZEm9sFRTE1tXY",
    authDomain: "https://comrounds-977c6.web.app/",
    databaseURL: "https://comrounds-977c6-default-rtdb.firebaseio.com/"
};

export default config;